import { evaluateExpression, isTruthy, validateExpression } from '@ayumia/core/expressions';
function isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
export function propertyForm(value) {
    if (value === null || typeof value === 'number' || typeof value === 'boolean')
        return 'literal';
    if (typeof value === 'string')
        return value.startsWith('$') ? 'binding' : 'literal';
    if (!isRecord(value))
        return null;
    const keys = Object.keys(value);
    if (keys.length === 1 && keys[0] === 'literal')
        return 'literal';
    if (keys.length === 1 && keys[0] === 'expression')
        return 'expression';
    if (Array.isArray(value['rules']) && keys.every((key) => key === 'rules' || key === 'default'))
        return 'rules';
    return null;
}
/** Valeur d'une règle : littéral ou liaison, jamais une expression imbriquée. */
function resolveRuleValue(value, scope, functions) {
    if (isRecord(value) && 'literal' in value)
        return value['literal'];
    return evaluateExpression(value, scope, functions === undefined ? {} : { functions });
}
export function resolveProperty(value, scope, functions) {
    const options = functions === undefined ? {} : { functions };
    switch (propertyForm(value)) {
        case 'literal':
            return isRecord(value) ? value['literal'] : value;
        case 'binding':
            return evaluateExpression(value, scope, options);
        case 'expression':
            return evaluateExpression(value.expression, scope, options);
        case 'rules': {
            const spec = value;
            for (const rule of spec.rules) {
                if (isTruthy(evaluateExpression(rule.when, scope, options)))
                    return resolveRuleValue(rule.value, scope, functions);
            }
            return 'default' in spec ? resolveRuleValue(spec.default, scope, functions) : null;
        }
        default:
            throw new TypeError('Valeur de propriété hors des quatre formes (58 §10).');
    }
}
/** Expressions contenues dans une valeur de propriété, avec leur chemin relatif. */
export function propertyExpressions(value) {
    switch (propertyForm(value)) {
        case 'binding':
            return [{ path: '', expression: value }];
        case 'expression':
            return [{ path: '/expression', expression: value.expression }];
        case 'rules': {
            const spec = value;
            const found = [];
            spec.rules.forEach((rule, index) => {
                found.push({ path: `/rules/${index}/when`, expression: rule.when });
                if (typeof rule.value === 'string' && rule.value.startsWith('$'))
                    found.push({ path: `/rules/${index}/value`, expression: rule.value });
            });
            if (typeof spec.default === 'string' && spec.default.startsWith('$'))
                found.push({ path: '/default', expression: spec.default });
            return found;
        }
        default:
            return [];
    }
}
export function validatePropertyValue(value, roots, functions) {
    if (propertyForm(value) === null)
        return [{ path: '', code: 'PROPERTY_FORM_INVALID', message: 'Une propriété est un littéral, une liaison, une expression ou des règles (58 §10).' }];
    const findings = [];
    if (propertyForm(value) === 'rules') {
        // Un texte est une expression valide mais toujours vraie : un `when` n'en est jamais un.
        value.rules.forEach((rule, index) => {
            if (typeof rule.when === 'string' && !rule.when.startsWith('$'))
                findings.push({ path: `/rules/${index}/when`, code: 'RULE_WHEN_TEXT', message: 'Une condition de règle est une expression, pas un texte.' });
        });
    }
    for (const { path, expression } of propertyExpressions(value)) {
        const options = functions === undefined ? { roots } : { roots, functions };
        for (const finding of validateExpression(expression, options))
            findings.push({ ...finding, path: `${path}${finding.path === '$' ? '' : finding.path}` });
    }
    return findings;
}
//# sourceMappingURL=properties.js.map